import { TEnumType, TEnumValue } from './model';

export const isInEnum = <TEnum extends TEnumType, TValue extends TEnumValue>(enumVariable: TEnum, value: TValue) =>
  Object.values(enumVariable).includes(value);

export const getEnum = <TEnum extends TEnumType, TValue extends TEnumValue>(enumVariable: TEnum, value: TValue) =>
  enumVariable[value as keyof typeof enumVariable];
